import { ICashBidConfig } from 'src/api/api'
import { sequence } from './utils'

export const cashBidConfigs: ICashBidConfig[] = []

export function createCashBidConfig(values: Partial<ICashBidConfig> = {}): ICashBidConfig {
  const id = sequence()
  return {
    id,
    api_type: `api-type-${id}`,
    api_url: `remote-id-${id}`,
    company_id: id,
    username: `remote-id-${id}`,
    password: `remote-id-${id}`,
    options: {},
    elevator_mapping: {},
    _revision: `fakeRevision-${id}`,
    ...values,
  }
}
